// Matches the HTML-escaped form of "text&lt;url&gt;" after < and > have been escaped.
// The url capture uses a negative lookahead to stop at &gt; without being confused by & in query params.
export const TEAMS_LINK_ESCAPED_REGEXP = /[\r\n|]([^_>\r\n|]*)&lt;(https?:\/\/(?:(?!&gt;)[^<>\r\n])*)&gt;/g;
